<template>
  <div class="BS-slide view-slide">
    <img src="../../assets/images/plotbook.png" />
    <div class="slide-text-part">
      <img src="../../assets/images/plot-book-logo-original.svg" v-on:click="select($event)">
      <!-- <h3 class="plotbook-logo">Plot<span>Book</span></h3> -->
      
     
      <span class="minimized-indicator">
        <div class="tooltip">
          <label class="opened">Opened</label>
          <label class="closed">Closed</label>
        </div>
      </span>
      <div class="clearfix"></div>
      <p>Geographical application that provides selection for Countries, States, Counties and Fields. Through different zoom levels it loads the suitable layer  </p>
      <div class="text-center">
        <button v-on:click="select($event)">OPEN APP</button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import baseAppComponent from "./baseAppComponent.vue";

export default {
  extends: baseAppComponent,
  name: "PlotBookComponent"
};
</script>

<style scoped>
.plotbook-logo{
  letter-spacing: 0px;
  font-weight: normal;
}
.plotbook-logo span{
  font-weight: bold
}
</style>